import React, { useState } from 'react';
import "../assets/css/login.css";
import { useNavigate } from 'react-router-dom';
import { Toaster, toast } from "react-hot-toast";
import configModule from '../../config.js';
import axios from "axios";

function Login() {
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const [loginData, setLoginData] = useState({
        investorId: "",
        password: "",
    });
    const config = configModule.config();
    const [loading, setLoading] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setLoginData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleLogin = async () => {
        const existingToken = localStorage.getItem("token");
        if (existingToken) {
            toast.error("Another user is already logged in this browser. Please log out and try logging in again");
            return;
        }

        if (!loginData.investorId.trim()) {
            toast.error("Investor ID is required");
            return;
        }

        if (!loginData.password.trim()) {
            toast.error("Password is required");
            return;
        }

        try {
            setLoading(true);

            const response = await axios.post(
                `${config.apiBaseUrl}/login`, loginData,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = response.data;

            localStorage.setItem("token", data.token);
            localStorage.setItem("user", JSON.stringify(data.user));

            toast.success("Login successful!");

            setTimeout(() => {
                navigate("/dashboard");
            }, 1000);

        } catch (error) {
            const message =
                error.response?.data?.message ||
                error.message ||
                "Something went wrong";

            toast.error(message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='d-center w-100 h-100'>
            <div className="page-wrap">
                <div className="panel-left">
                    <div className="brand">
                        <div className="brand-logo">
                            <div className="brand-icon">
                                <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 3v16h14v-3H7.5V3H4z" fill="#0a1628"></path>
                                    <path d="M4 3h3.5v10H4V3zM15 16h3v3h-3v-3z" fill="rgba(10,22,40,0.3)"></path>
                                </svg>
                            </div>
                            <div className="brand-name">
                                Lexora Holdings
                                <span>Private Limited</span>
                            </div>
                        </div>

                        <h2 className="panel-heading">Your <em>investments,</em><br />at a glance.</h2>
                        <div className="divider-rule"></div>
                        <p className="panel-subtext">Secure, real-time access to your portfolio performance, returns, and investment reports — all in one place.</p>
                    </div>

                    <div className="features">
                        <div className="feature-item"><div className="feature-dot"></div><span>Portfolio performance overview</span></div>
                        <div className="feature-item"><div className="feature-dot"></div><span>Investment returns &amp; statements</span></div>
                        <div className="feature-item"><div className="feature-dot"></div><span>Real-time insights &amp; analytics</span></div>
                        <div className="feature-item"><div className="feature-dot"></div><span>Secure 256-bit encrypted access</span></div>
                    </div>

                    <p className="panel-footer">© 2025 Lexora Holdings Pvt. Ltd., &nbsp;·&nbsp; Confidential</p>
                </div>


                <div className="panel-right">
                    <p className="form-eyebrow">Investor Portal</p>
                    <h1 className="form-title">Investors Login</h1>

                    <div className="input-group">
                        <label name="investor-id">Investor ID</label>
                        <div className="input-wrap w-100">

                            <svg className="input-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="8" cy="5" r="3" stroke="#0a1628" strokeWidth="1.5"></circle>
                                <path d="M2 13c0-2.5 2.7-4 6-4s6 1.5 6 4" stroke="#0a1628" strokeWidth="1.5" strokeLinecap="round"></path>
                            </svg>
                            <input
                                type="text"
                                name="investorId"
                                placeholder="e.g. LXH-00123"
                                value={loginData.investorId}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="input-group">
                        <label name="password">Password</label>
                        <div className="input-wrap w-100">
                            <svg className="input-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="3" y="7" width="10" height="7" rx="1.5" stroke="#0a1628" strokeWidth="1.5"></rect>
                                <path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" stroke="#0a1628" strokeWidth="1.5" strokeLinecap="round"></path>
                            </svg>
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                placeholder="Enter your password"
                                value={loginData.password}
                                onChange={handleInputChange}
                            />
                            <button className="eye-toggle" id="eyeToggle" onClick={() => setShowPassword(!showPassword)} aria-label="Toggle password visibility">
                                {showPassword ? (
                                    <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#0a1628"
                                        strokeWidth="1.8"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19C5 19 1 12 1 12a21.77 21.77 0 0 1 5.06-5.94" />
                                        <path d="M9.9 4.24A10.94 10.94 0 0 1 12 5c7 0 11 7 11 7a21.8 21.8 0 0 1-3.17 4.19" />
                                        <path d="M1 1l22 22" />
                                        <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                                    </svg>
                                ) : (
                                    <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#0a1628"
                                        strokeWidth="1.8"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
                                        <circle cx="12" cy="12" r="3" />
                                    </svg>
                                )}
                            </button>
                        </div>
                        <a className="forgot-link" onClick={() => navigate("/login/forgot-password")}>Forgot password?</a>
                    </div>

                    <button className="btn-login" id="loginBtn" onClick={handleLogin}
                        disabled={loading} >
                        <span className="btn-text"> {loading ? "Signing In..." : "Access Dashboard"} </span>
                        <span className="spinner"></span>
                    </button>

                    <div className="credentials-notice">
                        <svg className="notice-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                        <p><strong>Don't have credentials?</strong> Please contact your designated accountant to receive your Investor ID and password for portal access.</p>
                    </div>

                    <p className="form-copyright">This portal is exclusively for registered investors of Lexora Holdings Pvt. Ltd.<br />Unauthorised access is strictly prohibited.</p>
                </div>
            </div>

            <Toaster
                position="top-right"
                toastOptions={{
                    duration: 3000,
                    style: {
                        background: "#0a1628",
                        color: "#fff",
                        borderRadius: "10px",
                        padding: "14px 18px",
                    },
                    success: {
                        iconTheme: {
                            primary: "#22c55e",
                            secondary: "#fff",
                        },
                    },
                    error: {
                        iconTheme: {
                            primary: "#ef4444",
                            secondary: "#fff",
                        },
                    },
                }}
            />
        </div>
    )
}

export default Login;
